require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-ilaria-giannetti-the-construction-history-of-the-n-2-motorway-networking-on-reinforced-concrete-in-the-canton-of-ticino-lisbona-12-luglio-2021.json") })
        }
      }, "path---relazioni-e-conferenze-ilaria-giannetti-the-construction-history-of-the-n-2-motorway-networking-on-reinforced-concrete-in-the-canton-of-ticino-lisbona-12-luglio-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-ilaria-giannetti-the-construction-history-of-the-n-2-motorway-networking-on-reinforced-concrete-in-the-canton-of-ticino-lisbona-12-luglio-2021!./.cache/json/relazioni-e-conferenze-ilaria-giannetti-the-construction-history-of-the-n-2-motorway-networking-on-reinforced-concrete-in-the-canton-of-ticino-lisbona-12-luglio-2021.json
// module id = 700
// module chunks = 231608221292675